import { useEffect } from 'react'
import { useAppDispatch } from 'store/hooks'
import { Alert } from 'ui'

import style from './NotificationItem.module.scss'
import { NoticeInState, removeNotification } from './store'

type NotificationItemProps = {
  notice: NoticeInState
}

// попап-уведомление
export function NotificationItem({ notice }: NotificationItemProps) {
  const { severity, id, text } = notice
  const dispatch = useAppDispatch()

  const handleClose = () => {
    dispatch(removeNotification(id))
  }

  useEffect(() => {
    const timerForRemove = setTimeout(
      () => dispatch(removeNotification(id)),
      5000,
    )
    return () => {
      clearTimeout(timerForRemove)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Alert
      variant='filled'
      severity={severity}
      onClose={handleClose}
      className={style.alert}
    >
      {text}
    </Alert>
  )
}
